const POST_LOGIN_ROUTE_KEY = "myEconomy.postLoginRoute";

export function isMobileDevice() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const mobileUserAgent = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const touchDevice = navigator.maxTouchPoints > 0;
  const compactViewport = window.matchMedia("(max-width: 900px)").matches;

  return mobileUserAgent || (touchDevice && compactViewport);
}

export function defaultRouteName() {
  return isMobileDevice() ? "newReceipt" : "newTransactions";
}

export function rememberPostLoginRoute(fullPath) {
  if (typeof sessionStorage === "undefined" || !isSafeInternalRoute(fullPath)) {
    return;
  }

  try {
    sessionStorage.setItem(POST_LOGIN_ROUTE_KEY, fullPath);
  } catch (error) {
    // Storage can be unavailable in privacy mode. The device default remains a safe fallback.
  }
}

export function consumePostLoginRoute() {
  if (typeof sessionStorage === "undefined") {
    return null;
  }

  try {
    const fullPath = sessionStorage.getItem(POST_LOGIN_ROUTE_KEY);
    sessionStorage.removeItem(POST_LOGIN_ROUTE_KEY);
    return isSafeInternalRoute(fullPath) ? fullPath : null;
  } catch (error) {
    return null;
  }
}

function isSafeInternalRoute(fullPath) {
  return Boolean(
    fullPath &&
    fullPath.startsWith("/") &&
    !fullPath.startsWith("//") &&
    !fullPath.startsWith("/callback")
  );
}
